import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import { TranslatorPanel } from './components/TranslatorPanel';
import { ThemeProvider } from './components/theme-provider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="fo-translator-theme">
      <TranslatorPanel />
    </ThemeProvider>
  </React.StrictMode>
); 